import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import { ReactComponent as AirbnbIcon } from '../../assets/airbnb.svg';
import './ProvaSocialSection.css';

function StarRating() {
  return (
    <div className="prova-social-stars" role="img" aria-label="5 out of 5 stars">
      {[0, 1, 2, 3, 4].map((i) => (
        <svg key={i} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.6 6.9L12 17.3l-6.2 3.5 1.6-6.9-5.4-4.7 7.1-.6L12 2z" />
        </svg>
      ))}
    </div>
  );
}

function BookingLogo() {
  return (
    <p className="prova-social-booking-logo">
      <span className="prova-social-booking-logo__booking">Booking</span>
      <span className="prova-social-booking-logo__dot">.</span>
      <span className="prova-social-booking-logo__com">com</span>
    </p>
  );
}

function AirbnbMark() {
  return <AirbnbIcon className="prova-social-airbnb-mark" aria-hidden />;
}

function ProvaSocialSection() {
  const { language } = useLanguage();
  const t = translations?.[language]?.provaSocial || translations.en.provaSocial;
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % t.testimonials.length);
    }, 6000);
    return () => window.clearInterval(id);
  }, [t.testimonials.length]);

  return (
    <section className="prova-social-section" aria-labelledby="prova-social-heading">
      <div className="prova-social-section__inner">
        <header className="prova-social-header">
          <p className="prova-social-kicker">{t.kicker}</p>
          <span className="prova-social-divider" aria-hidden />
          <h2 id="prova-social-heading" className="prova-social-title">
            {t.title}
          </h2>
          <p className="prova-social-lead">{t.lead}</p>
        </header>

        <div className="prova-social-grid">
          <div className="prova-social-grid__cell prova-social-grid__cell--booking">
            <div className="prova-social-feature-top">
              <p className="prova-social-score">{t.booking.score}</p>
            </div>
            <div className="prova-social-feature-accent">
              <StarRating />
            </div>
            <div className="prova-social-feature-title">
              <p className="prova-social-score-label">{t.booking.label}</p>
            </div>
            <p className="prova-social-score-meta">{t.booking.reviews}</p>
            <BookingLogo />
          </div>

          <div className="prova-social-grid__cell prova-social-grid__cell--quote">
            <div className="prova-social-feature-top">
              <span className="prova-social-quote-mark" aria-hidden>
                &ldquo;
              </span>
            </div>
            <div className="prova-social-feature-accent" aria-hidden="true" />
            <div className="prova-social-feature-title">
              <blockquote className="prova-social-quote" key={activeIndex}>
                {t.testimonials[activeIndex].lines.map((line, lineIndex) => (
                  <p key={`${activeIndex}-${lineIndex}`}>{line}</p>
                ))}
              </blockquote>
            </div>
            <p className="prova-social-quote-label">{t.testimonialLabel}</p>
            <div className="prova-social-dots" role="tablist" aria-label="Guest reviews">
              {t.testimonials.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  role="tab"
                  aria-selected={index === activeIndex}
                  aria-label={`Review ${index + 1}`}
                  className={`prova-social-dot${index === activeIndex ? ' prova-social-dot--active' : ''}`}
                  onClick={() => setActiveIndex(index)}
                />
              ))}
            </div>
          </div>

          <div className="prova-social-grid__cell prova-social-grid__cell--superhost">
            <div className="prova-social-feature-top">
              <AirbnbMark />
            </div>
            <div className="prova-social-feature-accent" aria-hidden="true" />
            <div className="prova-social-feature-title">
              <div className="prova-social-superhost-brand">
                <p className="prova-social-superhost-title">{t.superhost.title}</p>
                <p className="prova-social-superhost-platform">{t.superhost.platform}</p>
              </div>
            </div>
            <p className="prova-social-superhost-desc">{t.superhost.description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProvaSocialSection;
